module.exports = __webpack_public_path__ + "static/media/dog-akita.3ea38137.png";